import React, { useState } from "react";
import NavBar from "./NavBar";
import { API_IP } from "../global_variables";
import BackgroundImage from "./../images/contactus_background.jpg";
import { useNavigate } from "react-router-dom";
import { axiosReqConfig } from "../functions/axiosRequest";

const BookConsultation = ({ services }) => {
  const [time, setTime] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [city, setCity] = useState("");
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [details, setDetails] = useState("");
  const [isEmailVisible, setIsEmailVisible] = useState(false);
  const [isCallVisible, setIsCallVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isFinished, setIsFinished] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputPhoneNumber = (event) => {
    setPhoneNumber(event.target.value);
  };
  const handleInputEmail = (event) => {
    setEmail(event.target.value);
  };
  const handleClickTime = (time) => {
    setTime(time);
  };

  const handleClickContact = (contact) => {
    setContact(contact);
    if (contact == "Email") {
      setIsEmailVisible(true);
      setIsCallVisible(false);
      setPhoneNumber("");
    } else {
      setIsCallVisible(true);
      setIsEmailVisible(false);
      setEmail("");
    }
  };

  const handleInputCity = (event) => {
    setCity(event.target.value);
  };

  const handleInputName = (event) => {
    setName(event.target.value);
  };

  const handleInputDetails = (event) => {
    setDetails(event.target.value);
  };

  const handleCheckboxServices = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedServices((prevServices) => [...prevServices, value]);
    } else {
      setSelectedServices((prevServices) =>
        prevServices.filter((service) => service !== value),
      );
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validation logic
    if (
      !time ||
      !contact ||
      !city ||
      !name ||
      selectedServices.length === 0 ||
      (contact === "Email" && !email) ||
      (contact === "Call" && !phoneNumber)
    ) {
      alert("Please fill in all required fields.");
      return;
    }
    setIsFinished(true);
    setIsLoading(true);

    const servicesString = selectedServices.join(", ");

    // If all fields are valid, proceed with submission
    const formData = {
      time,
      contact,
      city,
      name,
      email,
      phoneNumber,
      details,
      servicesString,
    };

    await axiosReqConfig(`${API_IP}/api/consultation`, "post", formData);
    setIsLoading(false);
  };

  return (
    <div className="consultationContainer">
      <div className="consultationLeftContent">
        <h1>Book a Free In-Home or Virtual Care Consultation</h1>
        <h5>
          Let’s connect. Our free in-home or virtual care consultations are an
          opportunity for us to get to know you, understand your needs, and
          discuss how iCare Village can support you or your loved one at home.
        </h5>
        <p>
          During this consultation, a member of our care team will listen
          carefully, answer your questions, and help identify the most
          appropriate services and next steps. There is no obligation and no
          pressure – we are here to help
        </p>
        <img
          src={require(`./../images/SeniorCare_1.jpg`)}
          className="consultationImage"
        />
        <button
          className="consultationLearnMoreButton"
          onClick={() => {
            navigate("/AboutUs");
          }}
        >
          Learn About Our Care Approach
        </button>
      </div>
      <div className="consultationRightContent">
        {!isFinished ? (
          <>
            <div className="consultationFormContainer">
              <div className="consultationFormTitle">
                <div>
                  <p>
                    Please complete the form below and a member of our iCare
                    Village care team will contact you within 24 hours.
                  </p>
                  <h4>When do you anticipate needing care support?*</h4>
                  <div className="consultationRadioList">
                    <div className="consultationRadioItem">
                      <input
                        type="radio"
                        id="consultationImmediately"
                        name="consultationSelection"
                        value="Immediately"
                        onClick={() => {
                          handleClickTime("Immediately");
                        }}
                      ></input>
                      <label htmlFor="consultationImmediately">
                        Immediately
                      </label>
                    </div>
                    <div className="consultationRadioItem">
                      <input
                        type="radio"
                        id="consultationWithinWeek"
                        name="consultationSelection"
                        value="Within A Week"
                        onClick={() => {
                          handleClickTime("Within A Week");
                        }}
                      ></input>
                      <label htmlFor="consultationWithinWeek">
                        Within a week
                      </label>
                    </div>
                    <div className="consultationRadioItem">
                      <input
                        type="radio"
                        id="consultationWithin30Days"
                        name="consultationSelection"
                        value="Within 30 Days"
                        onClick={() => {
                          handleClickTime("Within 30 Days");
                        }}
                      ></input>
                      <label htmlFor="consultationWithin30Days">
                        Within 30 days
                      </label>
                    </div>
                    <div className="consultationRadioItem">
                      <input
                        type="radio"
                        id="consultationWithin3Months"
                        name="consultationSelection"
                        value="Within 3 Months"
                        onClick={() => {
                          handleClickTime("Within 3 Months");
                        }}
                      ></input>
                      <label htmlFor="consultationWithin3Months">
                        Within 3 months
                      </label>
                    </div>
                    <div className="consultationRadioItem">
                      <input
                        type="radio"
                        id="consultationNotSure"
                        name="consultationSelection"
                        value="Not Sure"
                        onClick={() => {
                          handleClickTime("Not Sure");
                        }}
                      ></input>
                      <label htmlFor="consultationNotSure">Not sure yet</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="consultationFormBody">
                <div className="consultationFormPart">
                  <h4>Where will care be provided?*</h4>
                  <input
                    type="text"
                    placeholder="Victoria, BC"
                    value={city}
                    onChange={handleInputCity}
                  ></input>
                </div>
                <div className="consultationFormPart">
                  <h4>Which care services are you interested in?</h4>
                  <p>You may select more than one option</p>
                  <div className="consultationCheckboxGroup">
                    {services.map((service, index) => {
                      return (
                        <label className="consultationRadioItem">
                          <input
                            type="checkbox"
                            name="consultationServices"
                            value={service.care_service_name}
                            onChange={handleCheckboxServices}
                          />{" "}
                          {service.care_service_name}
                        </label>
                      );
                    })}
                  </div>
                </div>
                <div className="consultationFormPart">
                  <h4>
                    Please share any details about your needs or questions so
                    our care team can better support you.
                  </h4>
                  <textarea
                    name="consultationDetails"
                    rows="5"
                    value={details}
                    placeholder="Tell us a little about the support you’re looking for, or any questions you may have."
                    onChange={handleInputDetails}
                  ></textarea>
                </div>
                <div className="consultationFormPart">
                  <h4 htmlFor="consultationName">Full Name*</h4>
                  <input
                    type="text"
                    id="consultationName"
                    name="consultationName"
                    value={name}
                    onChange={handleInputName}
                  />
                </div>
                <div className="consultationFormPart">
                  <h4>
                    How would you prefer a member of our care team to contact
                    you? *
                  </h4>
                  <div className="consultationRadioList">
                    <label className="consultationRadioItem">
                      <input
                        type="radio"
                        name="consultationContact"
                        value="Email"
                        onClick={() => {
                          handleClickContact("Email");
                        }}
                      />{" "}
                      Email
                    </label>
                    <label className="consultationRadioItem">
                      <input
                        type="radio"
                        name="consultationContact"
                        value="Call"
                        onClick={() => {
                          handleClickContact("Call");
                        }}
                      />{" "}
                      Phone Call
                    </label>
                    <label className="consultationRadioItem">
                      <input
                        type="radio"
                        name="consultationContact"
                        value="text"
                        onClick={() => {
                          handleClickContact("Text Message");
                        }}
                      />{" "}
                      Text Message
                    </label>
                  </div>
                </div>
                <div className="consultationFormPart">
                  {!isCallVisible && !isEmailVisible ? (
                    <>
                      <p>Please select one preferred contact method.</p>
                    </>
                  ) : (
                    <></>
                  )}
                  {isCallVisible ? (
                    <>
                      <h4 htmlFor="consultationName">Phone Number*</h4>
                      <input
                        type="text"
                        id="consultationName"
                        name="consultationName"
                        value={phoneNumber}
                        onChange={handleInputPhoneNumber}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                  {isEmailVisible ? (
                    <>
                      <h4 htmlFor="consultationName">Email*</h4>
                      <input
                        type="text"
                        id="consultationName"
                        name="consultationName"
                        value={email}
                        onChange={handleInputEmail}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="consultationFormPart">
                  <button
                    className="consultationSubmitButton"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                  <p className="ContactUSNoteText">
                    A member of our iCare Village care team will respond within
                    24 hours.
                  </p>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {!isLoading ? (
              <>
                <div className="consultationFinishedContainer">
                  <h3>Your request has been submitted!</h3>
                  <img src={require(`../images/submit-img.png`)} />
                </div>
              </>
            ) : (
              <>
                <div className="consultationFinishedContainer">
                  <h3>Submitting...</h3>
                  <img src={require(`../images/loading_icon.gif`)} />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BookConsultation;
